const getColumnsDepth = function (columns) {
  let currentDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  const depths = [];
  for (const column of columns) {
    var _column$columns;
    if ((_column$columns = column.columns) !== null && _column$columns !== void 0 && _column$columns.length) {
      depths.push(getColumnsDepth(column.columns, currentDepth + 1));
    }
    depths.push(currentDepth);
  }
  return depths.sort((a, b) => b - a)[0];
};
export const getMaxHeaderDepth = columns => {
  const depthArray = [];
  for (const column of columns) {
    var _column$columns2;
    if ((_column$columns2 = column.columns) !== null && _column$columns2 !== void 0 && _column$columns2.length) {
      const nextDepth = getColumnsDepth(column.columns);
      depthArray.push(nextDepth);
    }
    depthArray.push(1);
  }
  return depthArray.sort((a, b) => b - a)[0];
};
const createMaxDeepColumnWithCustomCell = (originalColumn, Cell) => {
  const newColumn = {
    Header: '',
    hasCustomCell: true,
    accessor: originalColumn.accessor,
    id: originalColumn.isCollapsable ? "_".concat(originalColumn.id) : originalColumn.id,
    Cell: Cell,
    width: originalColumn.width
  };
  return newColumn;
};
const createMaxDeepColumn = originalColumn => {
  const newColumn = {
    Header: '',
    accessor: originalColumn.accessor,
    id: originalColumn.isCollapsable ? "_".concat(originalColumn.id) : originalColumn.id,
    width: originalColumn.width
  };
  return newColumn;
};
const generateEmptyNestedColumn = (originalColumn, currentDepth) => {
  const newColumn = {
    Header: '',
    accessor: "".concat(currentDepth, "_").concat(originalColumn.accessor),
    id: "".concat(currentDepth, "_").concat(originalColumn.id)
  };
  return newColumn;
};
const generateMaxNestedColumn = (originalColumn, Cell) => {
  if (Cell) {
    return createMaxDeepColumnWithCustomCell(originalColumn, Cell);
  }
  return createMaxDeepColumn(originalColumn);
};
const createColumnsArrayByDepth = (originalColumn, maxDepth, Cell) => {
  const newColumns = [];
  for (let currentDepth = maxDepth - 1; currentDepth > 0; currentDepth--) {
    if (currentDepth === 1) {
      const newMaxDepthColumn = generateMaxNestedColumn(originalColumn, Cell);
      newColumns.push(newMaxDepthColumn);
      break;
    }
    const newEmptyColumn = generateEmptyNestedColumn(originalColumn, currentDepth);
    newColumns.push(newEmptyColumn);
  }
  return newColumns;
};
export const generateColumnsIfCollapsed = (originalColumn, maxDepth, Cell) => {
  const newColumns = createColumnsArrayByDepth(originalColumn, maxDepth, Cell);
  const object = newColumns[0];
  let o = object;
  let result = o;
  for (let i = 1; i < newColumns.length; i++) {
    o.columns = [newColumns[i]];
    o = o.columns[0];
  }
  return result;
};